import React, { Component } from 'react';
import { Button } from 'antd';
import { observer, inject } from 'mobx-react';
import withRouter from '../../../components/withRouter';
import { getQuestionnairePop } from '@/api/myQuestionnaire';
import AuthStyle from '@/components/Auth/style.m.less';
@inject('store')
@observer
class QuestionModal extends Component<any, any> {
    async componentDidMount() {
        const { teachBusiness } = this.props.store;
        await teachBusiness.getCompositeDetailModal({
            business_id: this.props.business_id,
            template_id: this.props.template_id
        });
    }
    goToQuestion = () => {
        const {
            teachBusiness: {
                state: { projectDetail = {} },
                currentQuestionnaireIndex
            }
        } = this.props.store;
        const questionInfo = projectDetail.questionnaire_list?.length ? projectDetail.questionnaire_list[currentQuestionnaireIndex] : {};
        this.props.navigate(
            `/competition/question-sheet?business_id=${questionInfo.business_id}&template_id=${questionInfo.template_id}&relation_business_id=${questionInfo.relation_business_id}&relation_template_id=104`
        );
    };

    handleCancel = async () => {
        const {
            teachBusiness: {
                state: { projectDetail },
                currentQuestionnaireIndex,
                showNextQuestionnaire
            },
            face
        } = this.props.store;
        const questionInfo = projectDetail.questionnaire_list?.length ? projectDetail.questionnaire_list[currentQuestionnaireIndex] : {};
        if (questionInfo?.required === 2 && questionInfo?.pop_number === 2) {
            await getQuestionnairePop({
                business_id: questionInfo.business_id,
                template_id: questionInfo.template_id,
                relation_business_id: questionInfo.relation_business_id
            });
        }
        const currentPrompt = face.promptboxData.filter((item) => item.function_type === 4)[0];

        if (currentPrompt.number <= 1) {
            face.setCurrentPromptbox({});
            return;
        }
        let promptboxData = face.promptboxData;
        promptboxData.splice(
            promptboxData.findIndex((item) => item.function_type === 4),
            1,
            Object.assign({}, currentPrompt, { number: currentPrompt.number - 1 })
        );
        face.setPromptboxData([...promptboxData]);
        showNextQuestionnaire();
    };

    render() {
        const {
            teachBusiness: {
                state: { projectDetail = {} },
                currentQuestionnaireIndex
            }
        } = this.props.store;

        const questionInfo = projectDetail.questionnaire_list?.length ? projectDetail.questionnaire_list[currentQuestionnaireIndex] : {};

        return (
            <>
                <div
                    className={AuthStyle.authModalContent}
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '20px',
                        fontWeight: '500',
                        color: 'rgba(0,0,0,0.85)'
                    }}
                >
                    {questionInfo?.title}
                </div>
                <div className={AuthStyle.authModalButton}>
                    {questionInfo?.required === 1 ? null : (
                        <Button
                            style={{
                                width: '262px',
                                marginRight: '24px'
                            }}
                            onClick={this.handleCancel}
                        >
                            暂不作答
                        </Button>
                    )}
                    <Button style={{ width: '262px' }} type="primary" onClick={this.goToQuestion}>
                        填写问卷
                    </Button>
                </div>
            </>
        );
    }
}

export default withRouter(QuestionModal);
